// tslint:disable
export var TCSPhoneType;
(function (TCSPhoneType) {
    // Cell
    TCSPhoneType[TCSPhoneType["Cell"] = 0] = "Cell";
    // Fax
    TCSPhoneType[TCSPhoneType["Fax"] = 1] = "Fax";
    // Home
    TCSPhoneType[TCSPhoneType["Home"] = 2] = "Home";
    // Work
    TCSPhoneType[TCSPhoneType["Work"] = 3] = "Work";
})(TCSPhoneType || (TCSPhoneType = {}));
TCSPhoneType['CELL'] = 0;
TCSPhoneType['FAX'] = 1;
TCSPhoneType['HOME'] = 2;
TCSPhoneType['WORK'] = 3;
//# sourceMappingURL=TCSPhoneType.js.map